import React from "react";
import styled from "styled-components";

interface Props {
    size?: number
    fill?: string
}

export const MailIcon: React.FC<Props> = ({ size = 24, fill = '#fff' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 24 24">
    <g stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" clipPath="url(#a)">
        <path d="m21 5.25-9 8.25-9-8.25"/>
        <path d="M3 5.25h18V18a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 18V5.25ZM10.364 12l-7.132 6.538M20.768 18.538 13.636 12"/>
    </g>
    <defs>
        <clipPath id="a">
        <path fill={fill} d="M0 0h24v24H0z"/>
        </clipPath>
    </defs>
    </svg>
  );
};